<div class="message-create" [class.open]="messagePanelService.isOpen()">
    <form [formGroup]="messageForm">
        <div class="header">
            <div class="title px-3xl d-flex justify-content-between align-items-center">
                <h2>Nowa wiadomość</h2>
                <div class="close">
                    <button pui-button variant="tertiary" (click)="onClose()"><pui-icon left icon="x-close" /></button>
                </div>
            </div>
            <div class="p-3xl">
                <div class="recipient d-flex gap-8 align-items-center">
                    <label>Do:</label>
                    <rqa-recipient-select formControlName="recipient" class="w-100"></rqa-recipient-select>
                </div>
                <div class="subject d-flex gap-8 align-items-center">
                    <label>Temat:</label>
                    <input type="text" formControlName="title" placeholder="Podaj temat wiadomości" />
                </div>
            </div>
        </div>
        <div class="body p-3xl">
            <!-- <label>Treść:</label> -->
            <quill-editor placeholder="Wpisz treść wiadomości" formControlName="content"
                [style]="{ height: '560px', width: '100%' }"></quill-editor>
        </div>
        <div class="footer p-3xl">
            <button [variant]="'primary'" pui-button class="w-100" (click)="onSend()">Wyślij wiadomość</button>
        </div>
    </form>
</div>